import { Component, OnInit } from '@angular/core';
import { HttpService } from '../service/http.service';
import { Promotion } from '../promotion';

@Component({
  selector: 'app-promotions',
  templateUrl: './promotions.component.html',
  styleUrls: ['./promotions.component.css']
})
export class PromotionsComponent implements OnInit {

  promotions: Promotion[] = [];
  displayOptions = [
    {label: "Promos en cours", value: 0},
    {label: "All Promos", value: 1},
  ];
  selectedDisplayOption = this.displayOptions[0].value;

  constructor(
    private httpService: HttpService
  ) { }

  ngOnInit() {
    this.httpService.getCurrentPromotions().subscribe(promos => {
      this.promotions = promos;
    });
  }

  getCurrent(){
    this.httpService.getCurrentPromotions().subscribe(promos => {
      this.promotions = promos;
    });
  }

  getAll(){
    this.httpService.getPromotions().subscribe(promos => {
      this.promotions = promos;
    });
  }

  updateView(){
    if(this.selectedDisplayOption == 0){
      this.getCurrent();
    } else {
      this.getAll();
    }
  }

}
